import { useRouteError } from "react-router-dom";
import { Box, Button, Divider, Flex, Text } from "@chakra-ui/react";
import { Header } from "../components/Header";
import { Limites } from "./Pdv/LImites";
import { Footer } from "../components/Footer";
import { MdOutlineBusAlert} from "react-icons/md";

const ErrorFallback = () => {
  const error = useRouteError();
  console.error("Erro de rota:", error);

  return (
    <Box
      display={"flex"}
      flexDir={"column"}
      justifyContent={"center"}
      width={"full"}
      alignItems={"center"}
    >
      <Flex
        maxWidth={{
          xs: "full",
          md: "90%",
        }}
        width={"100%"}
        flexDir={"column"}
        justifyContent={"center"}
      >
        <Header />
        <Box px={"1rem"} bg={"white"} w={"full"}>
          <Limites />
          <Divider />
        </Box>
        <Flex
          gap={4}
          pb={4}
          px={{
            sm: "4px",
            xl: "1rem",
          }}
          bg={"white"}
          flexDir={{
            xs: "column",
            md: "row",
          }}
          w={"full"}
        >
          <Box
            width={{
              sm: "full",
            }}
            alignItems={'center'}
            display={'flex'}
            flexDir={'column'}
            my={4}
          >
            <MdOutlineBusAlert size={68} />
            <Text fontSize="xl" color="" fontWeight="bold">
                Algo deu errado por aqui!
            </Text>
            <Text mt={2}>Tente recarregar a página e acessar novamente! Caso o erro persista entre em contato com suporte.</Text>
            <Button mt={4} onClick={() => window.location.reload()} colorScheme="purple">
              Recarregar
            </Button>
          </Box>
        </Flex>
        <Footer />
      </Flex>
    </Box>
  );
};

export default ErrorFallback;
